import React, { useState, useEffect, useRef }from 'react';
import { Table, Form, Row, Col, Button } from 'react-bootstrap';
import { firestore } from '../../firebase';
import { Link } from 'react-router-dom';
import { IoAdd } from 'react-icons/io5';

export default function SalesTable() {
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [sales, setSales] = useState([]);
    const [query, setQuery] = useState(firestore.collection('ventas').orderBy('fecha', 'desc').limit(20));
    const limit = useRef(20);
    const salesLength = useRef(0);

    function getSales() {
        setLoading(true);
        query.onSnapshot(querySnapshot => {
            const items = [];
            querySnapshot.forEach(doc => {
                const data = doc.data();
                let date = new Date(data.fecha.toDate());
                date = date.toLocaleDateString('es-ES', {
                    weekday: 'long', 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                });
                items.push({
                    id: doc.id,
                    codigo: data.codigo,
                    fecha: date,
                    vendedor: data.vendedor.nombre,
                    idVendedor: data.vendedor.id,
                    cliente: data.cliente.nombre,
                    idCliente: data.cliente.id,
                    confirmada: data.confirmada,
                    metodoPago: data.metodo_pago
                });
            })
            salesLength.current = items.length; 
            setSales(items);
            setLoading(false);
        })
    }

    function createQuery(e) {
        e.preventDefault();
        let newQuery = firestore.collection('ventas');

        if (search) {
            const searchArray = search.toLowerCase().split(' ')
            newQuery = newQuery.where('keywords', 'array-contains-any', searchArray)
        }

        setQuery(newQuery.orderBy('fecha', 'desc').limit(limit.current));
    }

    function handleScroll(e) {
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const windowBottom = window.innerHeight + window.pageYOffset;
        if (Math.ceil(windowBottom) >= docHeight && salesLength.current === limit.current) {
            limit.current = limit.current+20;
            createQuery(e);
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getSales();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])

    return (
        <>
            <Form onSubmit={createQuery}>
                <Row className="m-2">
                    <Col className="my-1" xs={12} sm={8} md={9}>
                        <Form.Group controlId="searchBar">
                            <Form.Control 
                            type="text" 
                            placeholder="Buscar por productos, cliente, vendedor..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col className="my-1" xs={12} sm={4} md={3}>
                        <Button type="submit">Buscar</Button>
                        <Button className="mx-1 py-0 px-1" href="/sales/create" style={{fontSize: "1.55rem"}}>
                            <IoAdd/>
                        </Button>
                    </Col>
                </Row>
            </Form>
            <Table responsive striped bordered className='m-auto'>
                <thead>
                    <tr>
                        <th>Código</th>
                        <th>Fecha</th>
                        <th>Vendedor</th>
                        <th>Cliente</th>
                        <th>Método de Pago</th>
                        <th>Confirmada</th>
                    </tr>
                </thead>
                <tbody>
                    {sales && 
                    sales.map(sale => {
                        return (
                            <tr key={sale.id}>
                                <td>
                                    <Link to={`/sales/view_${sale.id}`}>
                                        {sale.codigo}
                                    </Link>
                                </td>
                                <td>{sale.fecha}</td>
                                <td>
                                    <Link to={`/sellers/view_${sale.idVendedor}`}>
                                        {sale.vendedor}
                                    </Link>                               
                                </td>
                                <td>                                    
                                    <Link to={`/customers/view_${sale.idCliente}`}>
                                        {sale.cliente}
                                    </Link>  
                                </td>
                                <td>{sale.metodoPago}</td>
                                <td>
                                    {sale.confirmada ? 'Sí' : 'No'}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
            {loading && <h3 className="text-muted m-3">Cargando...</h3>}
        </>
    )
}